(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("santa-members-viewer-script", [], factory);
	else if(typeof exports === 'object')
		exports["santa-members-viewer-script"] = factory();
	else
		root["santa-members-viewer-script"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 